// extracted by mini-css-extract-plugin
export default {"actionArea":"Tickets_actionArea__UsXUY","seeDetailsButton":"Tickets_seeDetailsButton__+vOux","scanButton":"Tickets_scanButton__qSVCd"};